import { KeyValueDefault } from '@/main/models/common';

export enum PartTypeTypes {
  GET_PART_TYPE = '@partType/GET_PART_TYPE',
  GET_PART_TYPES_BY_SUPPLIER_MANUFACTURER = '@partType/GET_PART_TYPES_BY_SUPPLIER_MANUFACTURER',
  GET_PART_TYPES_BY_DIRECT_ASSIGN_CRITERIA = '@partType/GET_PART_TYPES_BY_DIRECT_ASSIGN_CRITERIA',
  SAVE_PART_TYPE = '@partType/SAVE_PART_TYPE',
  RESET_REDUCER_PART_TYPE = '@partType/RESET_REDUCER_PART_TYPE'
}

export interface PartTypeState {
  readonly partType: {
    data: KeyValueDefault[] | null;
    errorMessages: string[] | null;
    isError: boolean;
    isLoading: boolean;
  };
}

export interface GetPartType {
  type: typeof PartTypeTypes.GET_PART_TYPE;
}

export interface GetPartTypesBySupplierAndVehicleManufacturer {
  type: typeof PartTypeTypes.GET_PART_TYPES_BY_SUPPLIER_MANUFACTURER;
  payload: {
    guidSupplier: string,
    guidVehicleManufacturer: string
  };
}

export interface GetPartTypesByDirectAssignCriteria{
  type: typeof PartTypeTypes.GET_PART_TYPES_BY_DIRECT_ASSIGN_CRITERIA;
  payload:{
    guidClaim?: string;
    guidQuote?: string;
    guidQuoteProcurement?: string;
  }
}

export interface SavePartType {
  type: typeof PartTypeTypes.SAVE_PART_TYPE;
  payload: {
    data: KeyValueDefault[] | null;
    isError: boolean;
    errorMessages: string[] | null;
  };
}

export interface ResetReducerPartType {
  type: typeof PartTypeTypes.RESET_REDUCER_PART_TYPE;
}

export type PartTypeActionTypes =
  | GetPartType
  | GetPartTypesBySupplierAndVehicleManufacturer
  | GetPartTypesByDirectAssignCriteria
  | SavePartType
  | ResetReducerPartType;

